import { Component, OnInit } from '@angular/core';
import { TokenServiceService } from '../../services/token-service.service';
import { Transaction } from '../../models';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  transaction: Transaction;
  codeValidToken: number;

  constructor(private readonly tokenService: TokenServiceService) { }

  ngOnInit() {
    this.transaction = this.tokenService.getAndDecodeToken();
    this.codeValidToken = this.tokenService.getCodeValidToken();
  }

  isValidToken() {
    return this.codeValidToken !== GENERAL_CONSTANTS.INVALID_TOKEN;
  }
}
